(function () {
  'use strict';

  angular
    .module('app')
    .filter('onlyDate', onlyDate);

  /* @ngInject */
  function onlyDate() {
    return function (date) {
      if (!date) {
        return;
      }

      if (!(date instanceof moment)) {
        date = moment(date);
      }

      return date.format('DD-MM-YYYY');
    };
  }
})();